import Fab from "../../parts/Fab";
import Section from "../../parts/Section";
import { useSearchParams } from "react-router-dom";
import ListMine from "./ListMine";
import ListQueue from "./ListQueue";
import ListAll from "./ListAll";
import Tabs from "../../parts/Tabs";

const MyQuotesList = () => {
  const [searchParams] = useSearchParams();

  const tabs = [
    { label: "Meus", value: "" },
    { label: "Todos", value: "todos" },
    { label: "Fila", value: "fila" },
  ];

  const Content =
    searchParams.get("tab") === "todos"
      ? ListAll
      : searchParams.get("tab") === "fila"
        ? ListQueue
        : ListMine;

  return (
    <Section>
      <Tabs tabs={tabs} className="mb-4" />

      <Content />

      <Fab href="/meus-orcamentos/criar" />
    </Section>
  );
};

export default MyQuotesList;

export const Badge = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <span
    className={`text-xs font-bold text-gray-500 bg-gray-100 py-0.5 px-2 rounded-full whitespace-nowrap ${className}`}
    onClick={(e) => e.stopPropagation()}
  >
    {children}
  </span>
);
